function severityFromStatus(status) {
  if (!status || status === 'ok') return 'ok';
  if (status === 'fault' || status === 'error') return 'fault';
  return 'warning';
}

export function getComponentSeverity(component) {
  const alerts = Array.isArray(component.conditions) ? component.conditions : [];
  if (alerts.some((alert) => alert.severity === 'error')) return 'fault';
  if (alerts.length > 0) return 'warning';
  return severityFromStatus(component.status);
}

function isFaultedComponent(component) {
  return getComponentSeverity(component) !== 'ok';
}

export function countFaultedComponents(components) {
  return components.filter(isFaultedComponent).length;
}
